module.exports = __webpack_public_path__ + "2733a15dca0182e3c75c81fc5c67e3fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_medium_x1/public/history/6_0.jpg
// module id = 294
// module chunks = 0